import type { RecordFormField, RecordFormFields, RecordFormTab } from "../types";

export type RecordFormSectionGroup = {
  fields: RecordFormFields;
  section?: string;
};

export const isFieldVisible = (field: RecordFormField) => field.visible?.() ?? true;

export const getHeaderFields = (fields: RecordFormFields) =>
  fields.filter((field) => !field.tab && isFieldVisible(field));

export const getTabFields = (fields: RecordFormFields, tabName: string) =>
  fields.filter((field) => field.tab === tabName && isFieldVisible(field));

export const groupFieldsBySection = (fields: RecordFormFields): RecordFormSectionGroup[] => {
  const groups: RecordFormSectionGroup[] = [];

  fields.forEach((field) => {
    const lastGroup = groups[groups.length - 1];
    if (lastGroup && lastGroup.section === field.section) {
      lastGroup.fields.push(field);
      return;
    }
    groups.push({ fields: [field], section: field.section });
  });

  return groups;
};

export const getTabsWithVisibleFields = (fields: RecordFormFields, tabs: RecordFormTab[]) =>
  tabs.filter((tab) => tab.alwaysVisible || getTabFields(fields, tab.name).length > 0);
